import { useReactFlow } from 'reactflow';

const useUpdateNode = () => {
    const { setNodes } = useReactFlow();

    return (nodeId, newNodeData) => {
        setNodes((nodes) =>
            nodes.map((node) => (node.id === nodeId ? { ...node, data: { ...node.data, ...newNodeData } } : node)),
        );
    };
};

export default useUpdateNode;
